var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-ueditor-wrap',{attrs:{"config":_vm.myConfig},on:{"ready":_vm.ready},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-033e2fcf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyRichText.vue
// module id = KbfH
// module chunks = 38